import React, {ChangeEvent, MouseEvent, SetStateAction} from 'react'
import Axios from 'axios'
import './jobs-page.css'
import {ApplicationThankYou} from '../ApplicationThankYou/ApplicationThankYou'
import NewLoadingScreen from '../NewLoadingScreen/NewLoadingScreen'
import { Helmet } from 'react-helmet'
import { baseUrl } from '../assets/Animations'

const JobsPage: React.FC = () => {
    const [schools, setSchools] = React.useState([])
    const [application, setApplication] = React.useState<applicationData | null>({
        key1app: '',
        key2app: '',
        key3app: '',
        key4app: '',
        key5app: '',
        key6app: '',
        key7app: '',
        key8app: '',
        key9app: '',
        key10app: '',
        key11app: '',
        key12app: '',
        key13app: [],
        key14app: '',
        key15app: '',
        key16app: '',
        key17app: '',
        key18app: '',
        key19app: '',
        key20app: '',
        key21app: '',
        key22app: '',
        id: Math.random().toString(16).slice(2),
      })
    const [selectedSchool, setSelectedSchool] = React.useState<schoolData| null>(null)
    const [modal, setModal] = React.useState(false)
    const [thankyou, setThankYou] = React.useState(false)
    const [name, setName] = React.useState('')
    const [required, setRequired] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [schoolName, setSchoolName] = React.useState('')
    const [schoolBlurb, setSchoolBlurb] = React.useState('')
    const [schoolBlurb2, setSchoolBlurb2] = React.useState('')
    const [abbreviation, setAbbreviation] = React.useState('')
    const [boxChecked, setBoxChecked] = React.useState(false)
    const [selectedInstrument, setSelectedInstrument] = React.useState('')
    const [schoolBackgroundImage, setSchoolBackgroundImage] = React.useState('')
    const [hasLicense, setHasLicense] = React.useState(false)
    const [hasVehicle, setHasVehicle] = React.useState(false)
    const [hasBackgroundCheck, setHasBackgroundCheck] = React.useState(false)
    const [logoName, setLogoName] = React.useState('')
    const [website, setWebsite] = React.useState('')
    const [instruments, setInstruments] = React.useState<instrumentData[]>([])
    const [instrumentsIPlay, setInstrumentsIPlay] = React.useState<instrumentData[]>([])
    const [submitButtonStyle, setSubmitButtonStyle] = React.useState({backgroundColor: "#888", cursor: "default"})
    const [inputBorderColor, setInputBorderColor] = React.useState({borderColor: "red"})
    const [emailWarningDisplay, setEmailWarningDisplay] = React.useState({display: 'block'})

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    interface schoolData {
        id: '',
        schoolAbbreviation: '',
        name: '',
        towns: Array<{
          id: '',
          name: '',
          uri: string
        }>,
        about: Array<{
          id: '',
          text: string
        }>,
        instruments: Array<{
          id: '',
          name: '',
          uri: '',
          copy: Array<{
            id: '',
            text: string
          }>,
          video: {
            name: '',
            description: '',
            thumbnailUrl: '',
            uploadDate: '',
            embedUrl: '',
            hasPart: [{
              type: '',
              name: '',
              startOffset: number,
              url: string
            }]
          }
        }>,
        phoneNumber: '',
        city: '',
        state: '',
        email: '',
        logoUrl: '',
        favicon: '',
        facebookUrl: '',
        instagramUrl: '',
        faqs: Array<{
          id: '',
          question: '',
          answer: string
        }>,
        timeZone: string
      }
      
    interface instrumentData {
        id: '',
        name: '',
        uri: '',
        parentInstrument: '',
        instrumentGroup: string
      }
    
      interface applicationData {
        key1app: string,
        key2app: string,
        key3app: string,
        key4app: string,
        key5app: string,
        key6app: string,
        key7app: string,
        key8app: string,
        key9app: string,
        key10app: string,
        key11app: string,
        key12app: string,
        key13app: Array<{
          id: string,
          name: string,
          uri: string,
          parentInstrument: string,
          instrumentGroup: string
        }>,
        key14app: string,
        key15app: string,
        key16app: string,
        key17app: string,
        key18app: string,
        key19app: string,
        key20app: string,
        key21app: string,
        key22app: string,
        id: string,
      }


    React.useEffect(() => {
        Axios.get(`${baseUrl}/schools`, myHeader)
        .then((res) => {
            setSchools(res.data)
            setTheSchool(res.data)
        })
        .catch((err) => console.log(err))
        getInstruments()
    }, [])

    React.useEffect(() => {
        if(modal === true) {
            if (required === false) {
                setSubmitButtonStyle({
                  backgroundColor: "#888",
                  cursor: "default",
                });
                setInputBorderColor({borderColor: "red"});
                setEmailWarningDisplay({display: "block"});
              } else {
                setSubmitButtonStyle({
                  backgroundColor: "rgb(33, 156, 43)",
                  cursor: "pointer",
                });
                setInputBorderColor({borderColor: "rgb(33, 156, 43)"});
                setEmailWarningDisplay({display: "none"});
              }
        }
    }, [required, modal])

    React.useEffect(() => {
        setApplication((prev: applicationData | null) => ({ ...prev!, key17app: `${hasBackgroundCheck}`, key18app: `${hasVehicle}`, key19app: `${hasLicense}`}));
    }, [hasBackgroundCheck, hasVehicle, hasLicense])

    React.useEffect(() => {
        let allAreaCheckBoxes: HTMLCollectionOf<HTMLInputElement> = document.getElementsByClassName('area-checkbox') as HTMLCollectionOf<HTMLInputElement>
        let areasTeachIn = ''
        for(let i = 0; i < allAreaCheckBoxes.length; i++) {
            if(allAreaCheckBoxes[i].checked) {
                areasTeachIn = areasTeachIn + ' ' + allAreaCheckBoxes[i].value
            }
        }
        console.log(areasTeachIn)
        setApplication((prev: applicationData | null) => ({ ...prev!, key22app: areasTeachIn as string}));
    }, [boxChecked])

    const compareInstrumentNames = ( a: instrumentData, b: instrumentData ) => {
        if ( a.name < b.name ){
          return -1;
        }
        if ( a.name > b.name ){
          return 1;
        }
        return 0;
      }

    const getInstruments = () => {
        Axios.get(`${baseUrl}/inst`)
        .then((res) => {
            let myList = res.data
            myList.sort(compareInstrumentNames)
            setInstruments(myList)
        })
        .catch((err) => console.log(err))
    }

    const setTheSchool = (allSchoolsData: schoolData[]) => {

        let url = window.location.href
        if(url === 'http://localhost:3000/careers') {
            setSelectedSchool(allSchoolsData[0])
            let schoolWebsite = allSchoolsData[0].logoUrl.substring(0, allSchoolsData[0].logoUrl.length - 9)
            setSchoolName(allSchoolsData[0].name)
            setApplication((prev: applicationData | null) => ({ ...prev!, key14app: allSchoolsData[0].name}));
            setAbbreviation(allSchoolsData[0].schoolAbbreviation)
            setLogoName(allSchoolsData[0].logoUrl)
            setApplication((prev: applicationData | null) => ({ ...prev!, key15app: allSchoolsData[0].email}));
            setApplication((prev: applicationData | null) => ({ ...prev!, key16app: `apply@${allSchoolsData[0].email.split('@')[1]}`}));
            setSchoolBlurb(`We offer in-home lessons in and around ${allSchoolsData[0].city}, ${allSchoolsData[0].state}. We are always looking for inspiring, knowledgable, and fun teachers to share the joy of music with their students.`)
            setSchoolBlurb2('As musicians ourselves, we designed this school around the idea of giving our fellow musicians a good job that can coexist with performances, recording sessions, and other artistic endeavors. We will work with you to create a schedule that allows you to balance your music career with your teaching career - connecting you with families nearby, and taking care of all the administration so you can focus on the music.')
            setWebsite(schoolWebsite)
        } else {
            let trimmed = url.substring(8)
            let name = trimmed.split('.')[0]
            for(let i = 0; i < allSchoolsData.length; i++) {
                if(name === allSchoolsData[i].name.split(' ')[0].toLowerCase()) {
                    setSelectedSchool(allSchoolsData[i])
                    let schoolWebsite = allSchoolsData[i].logoUrl.substring(0, allSchoolsData[i].logoUrl.length - 9)
                    setSchoolName(allSchoolsData[i].name)
                    setApplication((prev: applicationData | null) => ({ ...prev!, key14app: allSchoolsData[i].name}));
                    setAbbreviation(allSchoolsData[i].schoolAbbreviation)
                    setLogoName(allSchoolsData[i].logoUrl)
                    setApplication((prev: applicationData | null) => ({ ...prev!, key15app: allSchoolsData[i].email}));
                    setApplication((prev: applicationData | null) => ({ ...prev!, key16app: `apply@${allSchoolsData[i].email.split('@')[1]}`}));
                    setSchoolBlurb(`We offer in-home lessons in and around ${allSchoolsData[i].city}, ${allSchoolsData[i].state}. We are always looking for inspiring, knowledgable, and fun teachers to share the joy of music with their students.`)
                    setSchoolBlurb2('As musicians ourselves, we designed this school around the idea of giving our fellow musicians a good job that can coexist with performances, recording sessions, and other artistic endeavors. We will work with you to create a schedule that allows you to balance your music career with your teaching career - connecting you with families nearby, and taking care of all the administration so you can focus on the music.')
                    setWebsite(schoolWebsite)
                }
            }
        }
    }

    React.useEffect(() => {
        if(application?.key3app !== '') {
            setRequired(true)
        } else {
            setRequired(false)
        }
    }, [application?.key3app])

    const toggleModal = () => {
        if(modal === false) {
            setModal(true)
        } else {
            setModal(false)
            setRequired(false)
        }
    }
    const closeModal = (id: string) => {
        if(id === 'jobs-page-modal-wrapper') {
            toggleModal()
        }
    }

    React.useEffect(() => {
        if(selectedInstrument !== '') {
            for(let i = 0; i < instruments.length; i++) {
                if(instruments[i].id === selectedInstrument) {
                    setInstrumentsIPlay((prev) => [...prev, instruments[i]] as instrumentData[])
                    setSelectedInstrument('')
                }
            }
        }
    }, [selectedInstrument])

    React.useEffect(() => {
        setApplication((prev: applicationData | null) => ({ ...prev!, key13app: instrumentsIPlay as instrumentData[]}));
    },[instrumentsIPlay])

    const removeAnInstrument = (theIndex: number) => {
        let tempList = instrumentsIPlay
        tempList.splice(theIndex, 1)
        setInstrumentsIPlay([...tempList])
    }


    const submitApplication = () => {
        setLoading(true)
        if(required === false) {
            return
        } else {
            setName(application?.['key1app'] || '' as string)

            Axios.put(`${baseUrl}/newteacherapplication`, {
                application: application
            })
            .then(response => {
                if(response.status === 200) {
                    toggleModal()
                    setLoading(false)
                    setThankYou(true)
                } else {
                    setLoading(false)
                    alert('Sorry! There seems to be a problem. Try submitting your application again.')
                }
            })
            .catch(e => {
                console.log('Oops ' + e)
                console.log(e)
            })
            Axios.post(`${baseUrl}/applicationhiringcard`, {
                application: application,
            })
            .then(response => {})
            .catch(e => {
                console.log('Oops ' + e)
                console.log(e)
            })
        }
    }

    if(modal === false) {
        return (
        <>
            <Helmet>
                <title>{`${schoolName} Careers`}</title>
            </Helmet>
            <div>
                {loading && <NewLoadingScreen message={"Submitting application..."} logo={logoName} />}
                <div className="jobs-page" style={{backgroundImage: `url(./${abbreviation}.jpg)`}}>
                    <ApplicationThankYou thankyou={thankyou} name={name} website={website}/>
                    <div className="jobs-page-logo" style={{backgroundImage: `url(${logoName})`}}></div>
                    <div className="jobs-page-headline">
                        Share the joy of music while pursuing your career at {schoolName}!
                    </div>
                    <div className="jobs-page-apply-button" onClick={() => toggleModal()}>Apply Now</div>
                    <div className="scroll-down-wrapper">
                        <div className="jobs-page-scroll-down-icon"></div>
                    </div>
                </div>
                <div>
                    <div className="jobs-page-description">
                        <div className="jobs-page-blurb-title">Welcome to <br></br> {schoolName}</div>
                        <div className="jobs-page-blurb">
                        {schoolBlurb} <br></br><br></br> {schoolBlurb2}
                        </div>
                    </div>
                </div>
            </div>
        </>
        )  
    } else {
        return (
        <>
            <Helmet>
                <title>{`${schoolName} Careers`}</title>
            </Helmet>
            <div>
                {loading && <NewLoadingScreen message={"Submitting application..."} />}
                <div className="jobs-page" style={{backgroundImage: `url(./${abbreviation}.jpg)`}}>
                    <ApplicationThankYou thankyou={thankyou} name={name}/>
                    <div className="jobs-page-logo" style={{backgroundImage: `url(${logoName})`}}></div>
                    <div className="jobs-page-headline">
                        Share the joy of music while persuing your career at {schoolName}!
                    </div>
                    <div className="jobs-page-apply-button" onClick={() => toggleModal()}>Apply Now</div>
                    <div className="scroll-down-wrapper">
                        <div className="jobs-page-scroll-down-icon"></div>
                    </div>
                </div>
                <div>
                    <div className="jobs-page-description">
                        <div className="jobs-page-blurb-title">Welcome to <br></br> {schoolName}</div>
                        <div className="jobs-page-blurb">
                        {schoolBlurb} <br></br><br></br> {schoolBlurb2} 
                        </div>
                    </div>
                </div>


    {/* --------------------APPLICATION-MODAL--------------------- */}

                <div 
                    className="jobs-page-modal-wrapper" 
                    id="jobs-page-modal-wrapper" 
                    onClick={(e) => {
                      if (e.target instanceof HTMLDivElement) {
                        closeModal(e.target.id);
                      }
                    }}
                >
                    <div className="jobs-page-application-modal">
                        <div className="jobs-page-modal-x-wrapper">
                            <div className="jobs-page-modal-x" onClick={() => toggleModal()}>x</div>
                        </div>
                        <div className="application-form-title">
                            Teacher Application
                        </div>
                        <div className="input-row">
                            <div className="input-name-wrapper">
                            <input className="jobs-page-inputs short" id="application-input-1" name="first-name" value={application?.key1app || ''} onChange={(e: ChangeEvent<HTMLInputElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key1app: e.target.value as string})); }} required />
                                <label htmlFor="first-name" className="ani-label-name">
                                    <span className="content-name">First Name</span>
                                </label>
                            </div>
                            <div className="input-last-name-wrapper">
                                <input className="jobs-page-inputs short" id="application-input-2" name="last-name" value={application?.key2app || ''} onChange={(e: ChangeEvent<HTMLInputElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key2app: e.target.value as string})); }} required/>
                                <label htmlFor="last-name" className="ani-label-name">
                                    <span className="content-name">Last Name</span>
                                </label>
                            </div>
                        </div>
                        <div className="input-row">
                            <div className="input-name-wrapper">
                                <input className="jobs-page-inputs short" id="application-input-3" style={inputBorderColor} value={application?.key3app} onChange={(e: ChangeEvent<HTMLInputElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key3app: e.target.value as string})); }} name="email-address" required/>
                                <label htmlFor="email-address" className="ani-label-name">
                                    <span className="content-name">Email Address*</span>
                                </label>
                            </div>
                            <div className="input-last-name-wrapper">
                                <input className="jobs-page-inputs short" id="application-input-4" name="phone-number" value={application?.key4app || ''} onChange={(e: ChangeEvent<HTMLInputElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key4app: e.target.value as string})); }} required/>
                                <label htmlFor="phone-number" className="ani-label-name">
                                    <span className="content-name">Phone Number</span>
                                </label>
                            </div>
                        </div>
                        <div className="input-row">
                        <div className="input-center-wrapper">
                                <input className="jobs-page-inputs short" id="application-input-5" name="current-city" value={application?.key5app || ''} onChange={(e: ChangeEvent<HTMLInputElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key5app: e.target.value as string})); }} required/>
                                <label htmlFor="current-city" className="ani-label-name">
                                    <span className="content-name center-name">Current City of Residence</span>
                                </label>
                            </div>
                        </div>
                        <div className="jobs-page-input-labels">Instrument(s) you teach</div>
                        <div className="app-checkbox-wrapper">
                            <select className='school-edit-town__new-town-dropdown' id="instrument-selector__id" value={selectedInstrument} onChange={(e) => setSelectedInstrument(e.target.value)}>
                                <option value='' default>+ Add An Instrument</option>
                                {instruments.map((inst) => <option key={inst.id} value={inst.id}>{inst.name}</option>)}
                            </select>
                        </div>
                        <div className='inst-chip__wrapper'>
                            {instrumentsIPlay.map((inst, index) => (
                                <div className='inst-box__wrapper' key={index}>
                                    <div className='inst-box__remove-x' onClick={() => removeAnInstrument(index)}>x</div>
                                    <div className='inst-box__inst-name'>{inst.name}</div>
                                </div>
                            ))}
                        </div>
                        {selectedSchool?.towns && selectedSchool?.towns.length > 1 &&
                            <div>
                                <div className="jobs-page-input-labels">Area(s) you will teach in</div>
                                <div className="app-checkbox-wrapper">
                                    {selectedSchool.towns.map((town, index) => (
                                        <div key={town.id} className="each-check-wrapper"> 
                                            <input type="checkbox" id="area-checkbox" className="area-checkbox" onClick={(e) => setBoxChecked(!boxChecked)} name={`area${index}`} value={town.name}></input>
                                            <label htmlFor={`area${index}`}>{town.name}</label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }
                        <div></div>
                        <div className="jobs-page-input-labels">How many years of teaching experience?</div>
                        <select className="jobs-page-select-bars" id="application-input-6" value={application?.key6app || ''} onChange={(e: ChangeEvent<HTMLSelectElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key6app: e.target.value as string})); }} >
                            <option value={''}>-</option>
                            <option value="1-2">1-2</option>
                            <option value="2-3">2-3</option>
                            <option value="3-5">3-5</option>
                            <option value="5-10">5-10</option>
                            <option value="10+">10+</option>
                        </select>
                        <div className="jobs-page-input-labels">How many years do you forsee staying with us?</div>
                        <select className="jobs-page-select-bars" id="application-input-7" value={application?.key7app || ''} onChange={(e: ChangeEvent<HTMLSelectElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key7app: e.target.value as string})); }}  >
                            <option value={''}>-</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5+</option>
                        </select>
                        {/* <div className="jobs-page-input-labels">Mile Radius</div> */}
                        {/* <select className="jobs-page-select-bars"  id="application-input-8" >
                            <option value='' default>-</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                        </select> */}
                        <div className="jobs-page-input-labels">Ideal Number of Students</div>
                        <select className="jobs-page-select-bars" id="application-input-9" value={application?.key9app || ''} onChange={(e: ChangeEvent<HTMLSelectElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key9app: e.target.value as string})); }}  >
                            <option value={''}>-</option>
                            <option value="1-10">1-10</option>
                            <option value="10-20">10-20</option>
                            <option value="20+">20+</option>
                        </select>
                        <div className="background-vehicle-wrapper">
                            <div className="each-check-wrapper background-checks">
                                <input type="checkbox" className="background-checkboxes" id="background-check" name="background-check" checked={hasBackgroundCheck} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setHasBackgroundCheck(e.target.checked)}}/>
                                <label htmlFor="background-check"> I am willing to undergo a background check, in accordance with local law/regulations.</label>
                            </div>
                            <div className="each-check-wrapper background-checks">
                                <input type="checkbox" className="background-checkboxes" id="vehicle-check" name="vehicle" checked={hasVehicle} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setHasVehicle(e.target.checked)}} />
                                <label htmlFor="vehicle">I have a reliable vehicle.</label>
                            </div>
                            <div className="each-check-wrapper background-checks">
                                <input type="checkbox" className="background-checkboxes" id="license-check" name="license" checked={hasLicense} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setHasLicense(e.target.checked)}} />
                                <label htmlFor="license">I have a valid driver's license.</label>
                            </div>
                        </div>
                        <div className="jobs-page-input-labels">Cover Letter: <span className="input-labels-small">Please explain why you think you'd be a good fit for our school</span></div>
                        <textarea className="jobs-page-textareas"  id="application-input-10" value={application?.key10app || ''} onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key10app: e.target.value as string})); }} />
                        <div className="jobs-page-input-labels">Please list your education <span className="input-labels-small">(feel free to include education that is in-progress)</span></div>
                        <textarea className="jobs-page-textareas" placeholder="Institutions, degrees, and graduation dates..."  id="application-input-11" value={application?.key11app || ''} onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key11app: e.target.value as string})); }} />
                        <div className="jobs-page-input-labels">Relevant Work Experience</div>
                        <textarea className="jobs-page-textareas"  id="application-input-12" value={application?.key12app || ''} onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key12app: e.target.value as string})); }} />
                        <div className="jobs-page-input-labels">Links to video or audio recordings of you playing</div>
                        <textarea className="jobs-page-textareas"  id="application-input-13" value={application?.key20app || ''} onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key20app: e.target.value as string})); }} />
                        <div className="jobs-page-input-labels">References: <span className="input-labels-small">Please list 2-3 professional references</span></div>
                        <textarea className="jobs-page-textareas" placeholder="Name, phone number, email address and relationship to you"  id="references" value={application?.key21app || ''} onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {setApplication((prev: applicationData | null) => ({ ...prev!, key21app: e.target.value as string})); }} />
                        <div className="email-warning" id="email-warning" style={emailWarningDisplay} >Please include your email address!</div>
                        <div className="jobs-page-submit-btn" id="jobs-page-submit-btn" style={submitButtonStyle} onClick={() => submitApplication()}>SUBMIT</div>
                        <div className="spacer"></div>
                    </div>
                </div>

            </div>
        </>
        )
    }
}

export default JobsPage